export default __webpack_public_path__ + "static/media/icon-eye-open.e30c6aa6.svg";